import React from 'react'
import "./Why_we_exist_card.css"

function Why_we_exist_card({ text, imgSrc }) {
    return (
        <>
            <section className='Why_we_exist_card margin_section'>
                <div>
                    <div className="img_holder">
                        <img src={imgSrc} alt="icon" className="icons_img" />
                    </div>
                    <div className="text_holder">

                        <p>{text}</p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Why_we_exist_card